<template>
  <div class="dic" :class="`dic--${insight.type}`">
    <div class="dic-ico" :style="icoStyle">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path :d="iconPath" />
      </svg>
    </div>
    <div class="dic-body">
      <span class="dic-tag" :style="{ color: tagColor }">{{ insight.tag }}</span>
      <p class="dic-title">{{ insight.title }}</p>
      <p class="dic-desc" v-html="insight.desc" />
      <a class="dic-cta" href="#" @click.prevent="$emit('cta', insight)">{{ insight.cta }}</a>
    </div>
  </div>
</template>

<script>
const META = {
  warn:  { rgb: '255,90,107',   path: 'M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01' },
  ai:    { rgb: '232,106,16',   path: 'M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16zM3.27 6.96L12 12.01l8.73-5.05M12 22.08V12' },
  win:   { rgb: '40,199,111',   path: 'M22 11.08V12a10 10 0 11-5.93-9.14M22 4L12 14.01l-3-3' },
  info:  { rgb: '49,143,235',   path: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 8h.01M11 12h1v4h1' },
}

export default {
  name: 'DashInsightCard',
  props: {
    insight: { type: Object, required: true },
  },
  computed: {
    meta() { return META[this.insight.type] || META.info },
    tagColor() {
      const c = { warn: '#FF5A6B', ai: '#E86A10', win: '#28C76F', info: '#318feb' }
      return c[this.insight.type] || '#318feb'
    },
    iconPath() { return this.meta.path },
    icoStyle() {
      const rgb = this.meta.rgb
      return { background: `rgba(${rgb},.14)`, color: `rgb(${rgb})` }
    },
  },
}
</script>

<style>
.dic {
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  background: rgba(255,255,255,.025);
  border: 1px solid var(--wr-line);
  border-radius: 12px;
  transition: border-color .2s, background .2s;
  cursor: pointer;
}
.dic:hover { border-color: var(--wr-line-strong); background: rgba(255,255,255,.04); }
.dic-ico { width: 34px; height: 34px; border-radius: 9px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 1px; }
.dic-body { flex: 1; min-width: 0; }
.dic-tag { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; display: block; margin-bottom: 3px; }
.dic-title { font-size: 13px; font-weight: 700; color: var(--wr-text); margin: 0 0 4px; line-height: 1.4; }
.dic-desc { font-size: 12.5px; color: var(--wr-mute); margin: 0 0 8px; line-height: 1.5; }
.dic-desc b { color: var(--wr-text); font-weight: 600; }
.dic-cta { font-size: 12.5px; font-weight: 700; color: #F08023; text-decoration: none; }
.dic-cta:hover { text-decoration: underline; }
</style>
